<template>
  <div class="institutional-logos-banner" :class="variant">
    <img
      src="@/assets/images/logo-financiado-union-europea.png"
      alt="Financiado por la Unión Europea - NextGenerationEU"
      class="institutional-logo"
    />
    <img
      src="@/assets/images/logo-minsterio-educacion-formacion-profecional-deportes-amarillo.jpg"
      alt="Ministerio de Educación, Formación Profesional y Deportes"
      class="institutional-logo"
    />
    <img
      src="@/assets/images/logo-plan-recuperacion-transformacion-resilencia.png"
      alt="Plan de Recuperación, Transformación y Resiliencia"
      class="institutional-logo"
    />
    <img
      src="@/assets/images/logo_gobierno_aragon.png"
      alt="Gobierno de Aragón"
      class="institutional-logo"
    />    
    <img
      src="@/assets/images/logo_centros_excelencia.jpg"
      alt="Centros de Excelencia"
      class="institutional-logo"
    />
  </div>
</template>

<script>
export default {
  name: "InstitutionalLogosBanner",
  props: {
    variant: {
      type: String,
      default: "default", // 'default' for login, 'compact' for topbar
      validator: (value) => ["default", "compact"].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
.institutional-logos-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0; // Allow flex items to shrink below their content size

  .institutional-logo {
    height: 50px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    transition: opacity 0.3s ease;
    flex: 1 1 0; // Allow logos to grow and shrink equally
    min-width: 0; // Allow logos to shrink below content size
    max-height: 50px; // Maximum height constraint

    &:hover {
      opacity: 0.8;
    }
  }

  &.compact {
    gap: 0.75rem;

    .institutional-logo {
      height: 65px;
      max-height: 65px;
    }
  }

  // Responsive adjustments - Scale down proportionally to fit all 4 logos
  @media (max-width: 1200px) {
    gap: 1rem;

    .institutional-logo {
      height: 48px;
      max-height: 48px;
    }

    &.compact {
      gap: 0.75rem;

      .institutional-logo {
        height: 60px;
        max-height: 60px;
      }
    }
  }

  @media (max-width: 992px) {
    gap: 0.75rem;

    .institutional-logo {
      height: 45px;
      max-height: 45px;
    }

    &.compact {
      gap: 0.6rem;

      .institutional-logo {
        height: 55px;
        max-height: 55px;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 0.5rem;

    .institutional-logo {
      height: 40px;
      max-height: 40px;
    }

    &.compact {
      gap: 0.6rem;

      .institutional-logo {
        height: 50px;
        max-height: 50px;
      }
    }
  }

  @media (max-width: 576px) {
    gap: 0.5rem;

    .institutional-logo {
      height: 40px;
      max-height: 40px;
    }

    &.compact {
      gap: 0.4rem;

      .institutional-logo {
        height: 30px;
        max-height: 30px;
      }
    }
  }

  @media (max-width: 480px) {
    gap: 0.4rem;

    .institutional-logo {
      height: 35px;
      max-height: 35px;
    }

    &.compact {
      gap: 0.3rem;

      .institutional-logo {
        height: 28px;
        max-height: 28px;
      }
    }
  }

  @media (max-width: 360px) {
    gap: 0.3rem;

    .institutional-logo {
      height: 30px;
      max-height: 30px;
    }

    &.compact {
      gap: 0.25rem;

      .institutional-logo {
        height: 25px;
        max-height: 25px;
      }
    }
  }
}
</style>
